<template>
  <div class="container">
    <div style="height: 6%;overflow: hidden;">
      <div style="padding: 10px">
        <el-button id="expandAll" @click="expandAll()">展开</el-button>
        <el-button id="collapseAll" @click="unExpandAll">折叠</el-button>
        <el-button icon="el-icon-full-screen" @click="fullScreen">全屏</el-button>
        <el-button icon="el-icon-zoom-in zoomBtn" @click="zoomIN">放大</el-button>
        <el-button icon="el-icon-zoom-out zoomBtn" @click="zoomOut">缩小</el-button>
      </div>
    </div>
    <div class="left-container" style="height:93%;overflow: hidden">
      <gantt ref="gantt_here" :dataValue="dataValue" :tasks="tasks"></gantt>
    </div>
  </div>
</template>

<script>
import gantt from './components/GanttComponent.vue';

export default {
  name: "ganttChart",
  components: {gantt},
  data() {
    return {

      dataValue:{},

      tasks: {
        data: [],
        links: [
          // {id: 1, source: 1, target: 2, type: '0'}
        ]
      },

      calendarList: [],
    }
  },

  created() {
    this.ganttChartInitialization()

  },

  methods: {

    // 展开所有任务：
    expandAll() {
      this.$refs.gantt_here.expandAllS();
    },

    // 折叠所有任务：
    unExpandAll() {
      this.$refs.gantt_here.unExpandAllS();
    },

    // 全屏
    fullScreen() {
      this.$refs.gantt_here.fullScreenS();
    },

    // 放大
    zoomIN() {
      this.$refs.gantt_here.zoomINS();
    },

    // 缩小
    zoomOut() {
      this.$refs.gantt_here.zoomOutS();
    },

    // 初始化
    ganttChartInitialization() {
      // 获取表格数据
      let arr = sessionStorage.getItem("data")
      let table = JSON.parse(arr)
      this.dataValue = table
      console.log(table)
      let row = {
        id: '',
        wbs: '',
        text: '',
        start_date: '',
        // end_date: '',
        projectManager: '',
        director: '',
        projectType: '',
        executionStatus: '',
        duration: '',
        span: '',
        parent: '',
        open: true,
        color: ""
      }

      let ids = table.columnInfo.ids
      let name = this.getArrayIndex(ids,1054001)
      let type = this.getArrayIndex(ids,1054006)
      let start = this.getArrayIndex(ids,1054009)
      let finish = this.getArrayIndex(ids,1054010)
      let manager = this.getArrayIndex(ids,1054003)
      let director = this.getArrayIndex(ids,1054004)
      let executionStatus = this.getArrayIndex(ids,1054007)
      // 获取项目
      let projectNode = table.rows[0].cells
      row.id = table.rows[0].objId
      row.text = projectNode.at(name).val
      row.start_date = projectNode.at(start).val
      // row.end_date = this.dateFormat(projectNode.at(finish).val)
      row.projectManager = projectNode.at(manager).val
      row.director = projectNode.at(director).val
      row.projectType = projectNode.at(type).val
      row.executionStatus = projectNode.at(executionStatus).val
      row.open = true
      switch ((projectNode.at(executionStatus).val)) {
        case '待办':
          row.color = '#67d8c9'
          break
        case '进行中':
          row.color = '#a598f5'
          break
        case '待审核':
          row.color = '#67d8c9'
          break
        case '已完成':
          row.color = '#13ce66'
          break
      }
      // 实际工作日
      row.span = this.countWorkDay(projectNode.at(start).val,projectNode.at(finish).val)
      // 网格显示日期
      row.duration = this.days(projectNode.at(start).val,projectNode.at(finish).val)

      this.tasks.data.push(row)
      // 添加wbs
      let ganttWbs = this.getItemSeq(table.rows[0].children)
      let list = this.tasks.data
      // 获取任务
      this.filterData(ganttWbs, list,ids)
    },

    // 计算wbs
    getItemSeq(array, l, n) {
      if (!array || !array.length) return;
      let level = l || 1;
      let parentLevel = n || 0;
      array.forEach((item, e) => {
        item.seq = !parentLevel ? (e + 1 + '') : parentLevel + '.' + (e + 1 + '')
        if (item.children && item.children.length) {
          this.getItemSeq(item.children, level + 1, item.seq);
        }
      })
      // console.log(array);
      return array;
    },

    getCalendar() {
      this.$http
          .get("/ppm/calendar/loadCalendar?year=" + new Date().getFullYear())
          .then((res) => {
            // console.log(res);
            this.calendarList = res.data.object;
            this.cList = this.calendarList.map(
                (i) => i.exceptionDate.split("T")[0]
            );
            // console.log(this.cList);
          });
    },

    // 日期格式处理
    dateFormat(daterc) {
      if (daterc != null) {
        const date = new Date(daterc);
        const year = date.getFullYear();
        const month = date.getMonth() + 1 < 10 ? "0" + (date.getMonth() + 1) : date.getMonth() + 1;
        const day = date.getDate() < 10 ? "0" + date.getDate() : date.getDate();
        const hours = date.getHours() < 10 ? "0" + date.getHours() : date.getHours();
        const minutes = date.getMinutes() < 10 ? "0" + date.getMinutes() : date.getMinutes();
        const seconds = date.getSeconds() < 10 ? "0" + date.getSeconds() : date.getSeconds();
        // return year + "-" + month + "-" + day + " " + hours + ":" + minutes + ":" + seconds;
        return year + "-" + month + "-" + day
      }
    },

    // 获取下标
    getArrayIndex(arr, obj) {
      let i = arr.length;
      while (i--) {
        if (arr[i] === obj) {
          return i;
        }
      }
      return -1;
    },

    // 获取（开始减结束）时间
    days (start, end){
      return(new Date(end) - new Date(start)) / (1000 * 60 * 60 * 24).valueOf() + 1;
    },

    // 计算工作日
    // getWeekday(planBeginDate,planEndDate) {
    //   if (planBeginDate && planEndDate) {
    //     let first = new Date(planBeginDate);
    //     let last = new Date(planEndDate);
    //     first = first.getTime();
    //     last = last.getTime();
    //
    //     let count = 0;
    //     while (first <= last) {
    //       let d = new Date(first);
    //       if (d.getDay() >= 1 && d.getDay() <= 5) {
    //         count++;
    //       }
    //       first += 24 * 3600 * 1000;
    //     }
    //     count = count * 8;
    //     return count/8;
    //   }
    // },

    // 递归row
    filterData(data, list,ids) {
      let name = this.getArrayIndex(ids,1054001)
      let type = this.getArrayIndex(ids,1054006)
      let start = this.getArrayIndex(ids,1054009)
      let finish = this.getArrayIndex(ids,1054010)
      let manager = this.getArrayIndex(ids,1054003)
      let director = this.getArrayIndex(ids,1054004)
      let executionStatus = this.getArrayIndex(ids,1054007)
      data.forEach((item, index) => {
        let row = {
          id: '',
          wbs: '',
          text: '',
          start_date: '',
          // end_date: '',
          projectManager: '',
          director: '',
          projectType: '',
          executionStatus: '',
          duration: '',
          span: '',
          parent: '',
          open: true,
          color: ''
        }
        // console.log(item.cells.at(0).val)
        row.id = item.objId
        row.wbs = item.seq
        row.text = item.cells.at(name).val
        row.start_date = item.cells.at(start).val
        // row.end_date = this.dateFormat(item.cells.at(finish).val)
        row.projectManager = item.cells.at(manager).val
        row.director = item.cells.at(director).val
        row.projectType = item.cells.at(type).val
        row.executionStatus = item.cells.at(executionStatus).val
        row.open = true
        switch ((item.cells.at(executionStatus).val)) {
          case '待办':
            row.color = '#67d8c9'
            break
          case '进行中':
            row.color = '#a598f5'
            break
          case '待审核':
            row.color = '#ff9791'
            break
          case '已完成':
            row.color = '#13ce66'
            break
        }
        row.parent = item.parentRowId
        // 实际工作日
        row.span = this.countWorkDay(item.cells.at(start).val,item.cells.at(finish).val)
        // 网格显示日期
        row.duration = this.days(item.cells.at(start).val,item.cells.at(finish).val)
        list.push(row)
        if (item.children && item.children.length) {
          this.filterData(item.children, list,ids)
        }
      })
    }

  }
}
</script>

<style>
html, body {
  height: 100%;
  margin: 0;
  padding: 0;
}
.container {
  height: 100%;
  width: 100%;
  overflow: hidden;
}
.left-container {
  overflow: hidden;
  position: relative;
  height: 100%;
}
</style>
